import React from 'react'

const SelectInputWrapper = React.forwardRef((props, ref) => (
  <div className='form-group row'>
    <label className={`control-label col-lg-${props.labelColSize}`} htmlFor={props.name}>{props.label}</label>
    <div className={`col-lg-${props.inputColSize}`}>
      <select
        className='form-control'
        {...(_.omit(props, 'labelColSize', 'inputColSize'))}
        ref={ref}
        onChange={props.onChange} >
        {
          props.options.map((o, i) => <option key={i} value={o[0]}>{o[1]}</option>)
        }
      </select>
    </div>
  </div>
))

export default SelectInputWrapper
